<div class="inventory-container">
  <!-- Header -->
  <div class="inventory-header">
    <h1 class="inventory-title">Users ({{ totalItems }} total)</h1>
    <div class="header-actions">
      <input
        type="text"
        placeholder="Search users by name, email, or phone"
        class="search-input"
        (input)="onSearch($event)"
        [value]="searchTerm"
      />
      <button
        (click)="addUser()"
        class="add-button"
      >
        + Add User
      </button>
     <button
  (click)="openModal()"
  class="add-button"
>
  + Login User By Admin
</button>

    </div>
  </div>

  <!-- Pagination Info -->
  <div class="pagination-info-top" *ngIf="totalItems > 0">
    Showing {{ getStartIndex() }} to {{ getEndIndex() }} of {{ totalItems }} users
  </div>
          <div class="select-field">
  <label>Type</label>
  <ng-select 
    [items]="userTypes"
    [(ngModel)]="selectedType"
    (change)="onUserTypeChange()">
  </ng-select>
</div>

  <!-- Users Table -->
  <div class="users-table">
    <div class="table-header">
      <div class="header-cell">Avatar</div>
      <div class="header-cell name-cell">User Info</div>
      <div class="header-cell">Type</div>
      <div class="header-cell">Phone</div>
      <!-- <div class="header-cell">Banned</div> -->
      <div class="header-cell">Status</div>
      <div class="header-cell">Actions</div>
    </div>

    <div class="table-body">
      <ng-container *ngIf="users.length > 0; else noData">
        <ng-container *ngFor="let user of users">
          <!-- User Row -->
          <div class="user-row">
            <!-- الصورة -->
            <div class="cell image-cell">
              <img 
                [src]="(user.avatar | ImageUrlPipe) || 'assets/images/avatar-placeholder.png'"
                [alt]="user.name"
                class="user-avatar"
                appImageFallback
              />
            </div>

            <!-- معلومات المستخدم -->
            <div class="cell name-cell">
              <div class="user-name">{{ user.name || 'N/A' }}</div>
              <div class="user-meta">
                <span class="meta-item">
                  <span class="meta-label">Code:</span>
                  <span class="meta-value">{{ user.code || 'N/A' }}</span>
                </span>
                <span class="meta-item">
                  <span class="meta-label">Email:</span>
                  <span class="meta-value">{{ user.email || 'N/A' }}</span>
                </span>
              </div>
            </div>

            <!-- النوع -->
            <div class="cell type-cell">
              <span class="type-badge" [class]="getTypeClass(user.type)">
                {{ getUserType(user.type) }}
              </span>
            </div>

            <!-- الهاتف -->
            <div class="cell phone-cell">
              {{ user.phone || 'N/A' }}
            </div>

            <!-- Banned -->
            <!-- <div class="cell banned-cell">
              <div class="status-row">
                <label class="switch-container">
                  <input 
                    type="checkbox" 
                    [checked]="user.banned"
                    (change)="toggleBanned(user)"
                    class="toggle-switch"
                  />
                  <span class="slider"></span>
                </label>
                <span class="status-label" [class.banned]="user.banned">
                  {{ user.banned ? 'Yes' : 'No' }}
                </span>
              </div>
            </div> -->

            <!-- Status -->
            <div class="cell status-cell">
              <div class="status-row">
                <label class="switch-container">
                  <input 
                    type="checkbox" 
                    [checked]="user.status"
                    (change)="toggleStatus(user)"
                    class="toggle-switch"
                  />
                  <span class="slider"></span>
                </label>
                <span class="status-label" [class.active]="user.status">
                  {{ user.status ? 'Active' : 'Inactive' }}
                </span>
              </div>
            </div>

            <!-- الأزرار -->
            <div class="cell actions-cell">
              <div class="action-buttons">
                <button 
                  class="btn-edit"
                  (click)="openEditProfileModal(user)"
                  title="Edit User"
                >
                  ✏️
                </button>
                <button 
                  class="btn-delete"
                  (click)="deleteUser(user)"
                  title="Delete User"
                >
                  🗑️
                </button>
                <button 
                  class="btn-details"
                  (click)="viewDetails(user)"
                  title="View Details"
                >
                  👁️
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #noData>
        <div class="no-data-row">
          <div class="no-data-cell">
            {{ isLoading ? 'Loading users...' : 'No users found' }}
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Pagination Controls -->
  <div class="pagination-controls" *ngIf="totalPages > 1">
    <div class="pagination-info">
      Page {{ currentPage }} of {{ totalPages }}
    </div>
    
    <div class="pagination-buttons">
      <button 
        (click)="previousPage()" 
        [disabled]="currentPage === 1"
        class="pagination-btn">
        ‹ Previous
      </button>
      
      <div class="page-numbers">
        <button 
          *ngFor="let page of getPageNumbers()" 
          (click)="goToPage(page)"
          [class.active]="page === currentPage"
          class="page-btn">
          {{ page }}
        </button>
      </div>
      
      <button 
        (click)="nextPage()" 
        [disabled]="currentPage === totalPages"
        class="pagination-btn">
        Next ›
      </button>
    </div>

    <div class="items-per-page">
      <label>Show:</label>
      <select 
        [value]="itemsPerPage" 
        (change)="onItemsPerPageChange($event)">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </div>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="isLoading && users.length === 0" class="loading-indicator">
    <div class="spinner"></div>
    <span>Loading users...</span>
  </div>

  <!-- Empty State -->
  <div *ngIf="users.length === 0 && !isLoading && allUsers.length === 0" class="empty-state">
    <div class="empty-icon">👥</div>
    <h3>No users found</h3>
    <p>There are no users in the system yet.</p>
    <button (click)="addUser()" class="add-button">+ Add Your First User</button>
  </div>
</div>
<!-- Login User Modal -->
<div class="modal-backdrop" *ngIf="isModalOpen">
  <div class="modal">
    <h3>Login User</h3>

    <form #loginForm="ngForm">
      <input
        type="text"
        placeholder="User Name"
        [(ngModel)]="userName"
        name="userName"
        required
      />

      <small *ngIf="loginForm.submitted && !userName">
        User name is required
      </small>

      <input
        type="tel"
        placeholder="Phone Number"
        [(ngModel)]="phoneNumber"
        name="phoneNumber"
        required
        pattern="^[0-9]{10,15}$"
      />

      <small *ngIf="loginForm.submitted && !phoneNumber">
        Phone number is required
      </small>

      <div class="actions">
        <button
          type="button"
          (click)="submit(loginForm)"
          [disabled]="loginForm.invalid"
        >
          Submit
        </button>

        <button type="button" (click)="closeModal()">
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Edit Profile Modal -->
<div class="modal-backdrop" *ngIf="showEditProfileModal">
  <div class="modal-box">

    <!-- Header -->
    <div class="modal-header">
      <div class="modal-title-group">
        <div class="modal-icon">
          <i class="ti ti-user-edit"></i>
        </div>
        <div>
          <p class="modal-title">تعديل بيانات المستخدم</p>
          <p class="modal-subtitle">يُرجى تعديل الحقول المطلوبة فقط</p>
        </div>
      </div>
      <button class="modal-close" type="button" (click)="closeEditProfileModal()">
        <i class="ti ti-x"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <form [formGroup]="editProfileForm" (ngSubmit)="submitEditProfile()">

        <div class="form-group">
          <label>
            <i class="ti ti-id-badge"></i>
            الاسم
          </label>
          <input type="text" formControlName="name" placeholder="محمد أحمد" />
        </div>

        <div class="form-group">
          <label>
            <i class="ti ti-phone"></i>
            رقم الهاتف
          </label>
          <input type="text" formControlName="phone" placeholder="01xxxxxxxxx" dir="ltr" />
        </div>

        <div class="form-group">
          <label>
            <i class="ti ti-lock"></i>
            كلمة مرور جديدة
          </label>
          <div class="input-wrapper">
            <input type="password" formControlName="newPassword" placeholder="••••••••" />
            <i class="ti ti-eye input-icon"></i>
          </div>
          <p class="field-hint">اتركه فارغاً إذا لم تريد تغييره</p>
        </div>

      </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="closeEditProfileModal()">
        إلغاء
      </button>
      <button type="submit" class="btn-save" [disabled]="isUpdatingProfile"
              (click)="submitEditProfile()">
        <i class="ti ti-device-floppy"></i>
        حفظ التغييرات
      </button>
    </div>

  </div>
</div>